export const PageDataState = {
    Searchs: {
        department_id: {
            type: 'select',
            id: 'department_id',
            label: 'สาขาวิชา',
            value: '',
            placeholder: 'สาขาวิชา',
        },
        department_work_name: {
            type: 'text',
            id: 'department_work_name',
            label: 'สาขางาน',
            value: '',
            placeholder: 'สาขางาน',
        },
        department_work_status: {
            type: 'select',
            id: 'department_work_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        department_id: {
            type: 'select',
            id: 'department_id',
            label: 'สาขาวิชา',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}